module.exports = __webpack_public_path__ + "static/media/Huis-2-2.cf5f6d81.jpg";